import { render, staticRenderFns } from "./TestimonialsListCard.vue?vue&type=template&id=0756fc98&"
import script from "./TestimonialsListCard.vue?vue&type=script&lang=js&"
export * from "./TestimonialsListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports